var map = {
	"./apple-pay.png": "2788",
	"./de.png": "72fe",
	"./en.png": "9996",
	"./fr.png": "26fc",
	"./g-pay.png": "d102",
	"./iDEAL.png": "d3d3",
	"./payment.png": "9d04",
	"./pt.png": "5e3c",
	"./review.png": "3cd5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c99";